import PropTypes from "prop-types";
import React, { Component } from "react";
import { Grid, Box, CircularProgress, Typography } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import moment from "moment";
import { withTranslation } from "react-i18next";
import HeaderInfo from "../../waybee-ui/HeaderInfo/HeaderInfo";
import Group from "../../waybee-ui/Group";
import Divider from "../../waybee-ui/Divider";
import CollapseGroup from "../../waybee-ui/CollapseGroup";
import StudentService from "../../services/StudentService";
import DisciplineListItem from "./components/DisciplineListItem";
import BackButton from "../../components/BackButton";

const HeaderGrid = styled(Grid)`
  margin-bottom: -20px;
`;

const HeaderGroup = styled(Group)`
  padding-bottom: 0;
`;

const GeralAverage = styled.div`
  margin-bottom: 8px;
`;

class StudentStatistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      student: null,
      reportCards: [],
      loaded: false
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    const { studentId } = match.params;
    try {
      const student = await StudentService.getStudentById(studentId);
      await this.getStudentGrades(studentId);
      this.setState({ student, loaded: true });
    } catch (e) {
      console.error(e);
      this.setState({ loaded: true });
    }
  }

  getStudentGrades = async studentId => {
    const { t } = this.props;
    const grades = await StudentService.getGrades(studentId);
    const cards = (grades && grades.reportCards) || [];
    const reportCards = cards.map(grade => {
      let lastUpdate = null;
      if (grade.updatedAt) {
        const m = moment(grade.updatedAt);
        lastUpdate = t("student.stats.updatedAt", {
          date: m.format("DD/MM/YYYY"),
          time: m.format("HH:mm")
        });
      }
      return {
        id: grade.id,
        name: grade.course && grade.course.name,
        period: grade.course && grade.course.coursePeriodDescription,
        lastUpdate,
        disciplines: Array.isArray(grade.academicPeriods)
          ? grade.academicPeriods
          : []
      };
    });

    this.setState({ reportCards });
  };

  renderPeriodBody = period => {
    const { t } = this.props;
    const data = (period && period.data) || {};
    const disciplines = Array.isArray(data.disciplines) ? data.disciplines : [];
    const { geralAverageData, admissionStatusData } = data;

    return (
      <>
        {geralAverageData && (
          <GeralAverage>
            <DisciplineListItem
              color={geralAverageData.color}
              discipline={t("student.stats.overallAvg")}
              admissionStatus={admissionStatusData}
              average={geralAverageData.average}
            />
          </GeralAverage>
        )}
        {disciplines.map(discipline => {
          const mainAverage =
            Array.isArray(discipline.mainAverages) && discipline.mainAverages[0]
              ? discipline.mainAverages[0]
              : null;
          return (
            <DisciplineListItem
              key={discipline.id || discipline.name}
              discipline={discipline.name}
              color={discipline.color}
              teacher={discipline.teacher}
              average={
                mainAverage
                  ? {
                      value: mainAverage.value,
                      color: mainAverage.color
                    }
                  : undefined
              }
              description={mainAverage && mainAverage.description}
              evaluations={discipline.evaluations}
            />
          );
        })}
      </>
    );
  };

  render() {
    const { student, reportCards, loaded } = this.state;
    const { t } = this.props;
    if (!loaded || !student) {
      return (
        <Box p={6} textAlign="center">
          <CircularProgress />
        </Box>
      );
    }

    return (
      <Grid container spacing={2}>
        <BackButton to={`/student/${student.id}`} />
        <HeaderGrid item xs={12}>
          <HeaderGroup>
            <Box mb={2}>
              <HeaderInfo
                name={student.name}
                info={t("student.raInfo", { ra: student.ra })}
                photo={student.photo}
              />
            </Box>
            <Divider />
          </HeaderGroup>
        </HeaderGrid>
        {!reportCards.length && (
          <Grid item xs={12}>
            <Group>
              <Box p={3}>
                <Typography variant="h4">{t("student.stats.empty")}</Typography>
              </Box>
            </Group>
          </Grid>
        )}
        {reportCards.map(periods => (
          <Grid item xs={12} key={periods.id}>
            {(periods.disciplines || []).map(period => (
              <CollapseGroup key={period.id || period.name} title={period.name}>
                {this.renderPeriodBody(period)}
              </CollapseGroup>
            ))}
          </Grid>
        ))}
      </Grid>
    );
  }
}

StudentStatistics.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.objectOf(PropTypes.string)
  }).isRequired,
  t: PropTypes.func.isRequired
};
export default withRouter(withTranslation()(StudentStatistics));
